import { ComponentProps } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";

import { styled } from "~/application/theme";

export type SidebarOverlayProps = ComponentProps<typeof SidebarOverlay>;

export const SidebarOverlay = styled(DialogPrimitive.Overlay, {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100vh",
  backgroundColor: "rgba(99, 105, 115, 0.32)",
  zIndex: "$sidebar",
  "@mmd": {
    display: "none",
  },
});
